<script lang="ts">
import { computed } from 'vue';

import { PhxsgLoader } from '@sg-core/src/View/Components/Atoms/Loader';

export type ControlsPosition = 'top-start' | 'top-end' | 'bottom-start' | 'bottom-end';

export interface PhxsgBackgroundVideoControlsProps {
  position?: ControlsPosition | null;
  loader?: boolean;
}
</script>

<script setup lang="ts">
defineOptions({ inheritAttrs: false });

const { position = 'bottom-end', loader = true } = defineProps<PhxsgBackgroundVideoControlsProps>();

const positionClass = computed(() => `phxsg-background-video__controls--${position ?? 'bottom-end'}`);

const iconAttrs = (modifier: string) => ({
  class: `phxsg-background-video__icon phxsg-background-video__icon--${modifier}`,
});
</script>

<template>
  <div :class="['phxsg-background-video__controls', positionClass]">
    <PhxsgLoader v-if="loader" class="phxsg-background-video__loader" />

    <button
      class="phxsg-background-video__btn"
      type="button"
      data-background-video-control="play"
      data-lightbox-ignore
      v-bind="$attrs"
    >
      <slot name="play" :attrs="iconAttrs('play')" />
      <slot name="pause" :attrs="iconAttrs('pause')" />

      <slot />
    </button>

    <button
      v-if="$slots.mute || $slots.unmute"
      class="phxsg-background-video__btn"
      type="button"
      data-background-video-control="mute"
      data-lightbox-ignore
      v-bind="$attrs"
    >
      <slot name="unmute" :attrs="iconAttrs('unmute')" />
      <slot name="mute" :attrs="iconAttrs('mute')" />
    </button>
  </div>
</template>
